const state = { product: null, color: "groen", size: null, cart: [] };
const money = (value) =>
  new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: state.product?.currency || "EUR",
  }).format(value);

async function init() {
  try {
    state.product = JSON.parse(
      document.getElementById("product-data").textContent,
    );
    render();
    bindGlobal();
    await syncCart();
  } catch (error) {
    document
      .querySelector(".buy-panel")
      .insertAdjacentHTML(
        "beforeend",
        `<p class="selection">${error.message}. Vernieuw de pagina.</p>`,
      );
  }
}

function render() {
  const p = state.product;
  ["price", "button-price", "mobile-price"].forEach(
    (id) => (document.getElementById(id).textContent = money(p.price)),
  );
  document.getElementById("compare-price").textContent = money(p.compareAt);
  document.getElementById("saving").textContent =
    `Bespaar ${money(p.compareAt - p.price).replace(",00", "")}`;
  const colors = document.getElementById("color-options");
  const rack = document.getElementById("color-rack");
  p.colors.forEach((color) => {
    const unavailable = color.available === false;
    colors.insertAdjacentHTML(
      "beforeend",
      `<button class="swatch${unavailable ? " unavailable" : ""}" type="button" role="radio" aria-checked="${state.color === color.id}" aria-label="${color.label}${unavailable ? " – tijdelijk niet leverbaar" : ""}" data-color="${color.id}" style="background:${color.hex}" ${unavailable ? 'disabled aria-disabled="true"' : ""}></button>`,
    );
    rack.insertAdjacentHTML(
      "beforeend",
      `<button class="color-card${unavailable ? " unavailable" : ""}" type="button" data-color="${color.id}" style="--body:${color.hex};background:${color.hex}" ${unavailable ? 'disabled aria-disabled="true"' : ""}><span class="monster-head" aria-hidden="true"><span class="monster-hair"></span><span class="monster-eyes"><i></i><i></i></span><span class="monster-mouth"></span></span><span class="color-card-label">${color.label}${unavailable ? "<small>Tijdelijk niet leverbaar</small>" : ""}</span></button>`,
    );
  });
  const sizes = document.getElementById("size-options");
  ["Kind", "Volwassene"].forEach((group) => {
    const groupSizes = p.sizes.filter((size) => size.group === group);
    sizes.insertAdjacentHTML(
      "beforeend",
      `<div class="size-group"><span class="size-group-label">${group === "Kind" ? "Kinderen" : "Volwassenen"}</span><div class="size-group-buttons">${groupSizes.map((size) => `<button class="size-button" type="button" data-size="${size.id}" aria-pressed="false">${size.label.replace("Kindermaat ", "").replace("Volwassen ", "")}</button>`).join("")}</div></div>`,
    );
  });
  const table = document.getElementById("size-table");
  p.sizes.forEach((size) =>
    table.insertAdjacentHTML(
      "beforeend",
      `<tr><td>${size.group}</td><td>${size.label}</td><td>${size.height}</td></tr>`,
    ),
  );
  document
    .querySelectorAll("[data-color]")
    .forEach((button) =>
      button.addEventListener("click", () => chooseColor(button.dataset.color)),
    );
  document
    .querySelectorAll("[data-size]")
    .forEach((button) =>
      button.addEventListener("click", () => chooseSize(button.dataset.size)),
    );
}

function chooseColor(id) {
  const color = state.product.colors.find((item) => item.id === id);
  if (!color || color.available === false) return;
  state.color = id;
  document.getElementById("color-name").textContent = color.label;
  document
    .querySelectorAll(".swatch")
    .forEach((button) =>
      button.setAttribute("aria-checked", button.dataset.color === id),
    );
  updateSelection();
}
function chooseSize(id) {
  state.size = id;
  document
    .querySelectorAll(".size-button")
    .forEach((button) =>
      button.setAttribute("aria-pressed", button.dataset.size === id),
    );
  updateSelection();
}
function updateSelection() {
  const color = state.product.colors.find((item) => item.id === state.color);
  const size = state.product.sizes.find((item) => item.id === state.size);
  const text = size
    ? `${color.label} · ${size.label} · ${size.height}`
    : "Kies nog een maat";
  document.getElementById("selection").textContent = text;
  document.getElementById("mobile-selection").textContent = size
    ? `${color.label} · ${size.label}`
    : "Kies kleur & maat";
  document.getElementById("add-to-cart").disabled = !size;
}
async function addToCart() {
  const color = state.product.colors.find((item) => item.id === state.color);
  const size = state.product.sizes.find((item) => item.id === state.size);
  if (!size) return;
  const variant = state.product.variants.find(
    (item) => item.option1 === color.option && item.option2 === size.label,
  );
  if (!variant) {
    showToast("Deze combinatie is niet beschikbaar");
    return;
  }
  const button = document.getElementById("add-to-cart");
  button.disabled = true;
  try {
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
    });
    if (!response.ok) throw new Error("Toevoegen mislukt");
    await syncCart();
    showToast("Monster toegevoegd aan je tas");
    openCart();
  } catch (error) {
    showToast(error.message);
  } finally {
    button.disabled = false;
  }
}
const escapeHtml = (value) =>
  String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");

function renderCart(cart) {
  state.cart = cart.items;
  document.getElementById("cart-count").textContent = cart.item_count;
  const content = document.getElementById("cart-content");
  if (!cart.item_count) {
    content.innerHTML = '<p class="empty">Je tas is nog leeg.</p>';
    return;
  }
  const lines = cart.items
    .map((item) => {
      const image = item.featured_image?.url || item.image || state.product.image;
      const options = item.variant_options
        .filter((option) => option !== "Default Title")
        .map((option) => escapeHtml(option))
        .join("<br>");
      return `<article class="cart-item"><img src="${escapeHtml(image)}" alt="${escapeHtml(item.product_title)}"><div><b>${escapeHtml(item.product_title)}</b><p>${options}</p><strong>${money(item.final_line_price / 100)}</strong><small>Aantal: ${item.quantity}</small></div></article>`;
    })
    .join("");
  content.innerHTML = `${lines}<a class="add-button" href="${window.Shopify.routes.root}cart">Naar mijn winkelwagen</a>`;
}

async function syncCart() {
  const response = await fetch(window.Shopify.routes.root + "cart.js", {
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Winkelmand laden mislukt");
  renderCart(await response.json());
}

async function openCart() {
  document.body.classList.add("cart-open");
  document.getElementById("cart").classList.add("open");
  document.getElementById("cart").setAttribute("aria-hidden", "false");
  document.querySelector(".cart-button").setAttribute("aria-expanded", "true");
  document.getElementById("scrim").classList.add("show");
  document.getElementById("close-cart").focus();
  try {
    await syncCart();
  } catch (error) {
    showToast(error.message);
  }
}
function closeCart() {
  document.body.classList.remove("cart-open");
  document.getElementById("cart").classList.remove("open");
  document.getElementById("cart").setAttribute("aria-hidden", "true");
  document.querySelector(".cart-button").setAttribute("aria-expanded", "false");
  document.getElementById("scrim").classList.remove("show");
}
function showToast(message) {
  const toast = document.getElementById("toast");
  toast.textContent = message;
  toast.classList.add("show");
  window.setTimeout(() => toast.classList.remove("show"), 2200);
}
function bindGlobal() {
  document.getElementById("add-to-cart").addEventListener("click", addToCart);
  document.querySelector(".cart-button").addEventListener("click", openCart);
  document.getElementById("close-cart").addEventListener("click", closeCart);
  document.getElementById("scrim").addEventListener("click", closeCart);
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeCart();
  });
  document
    .querySelectorAll("[data-scroll]")
    .forEach((button) =>
      button.addEventListener("click", () =>
        document
          .querySelector(button.dataset.scroll)
          .scrollIntoView({ behavior: "smooth" }),
      ),
    );
}
init();
